import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

import { UUID_PATTERN } from "./types.ts";

export const EntraIdComponents = InstallSpec({
  base: ItemComponent({
    label: "Base installation",
    description:
      "Defines how P0 connects to your Entra ID Enterprise Application",
    type: "generated",
    hidden: true,
    maturity: "ga",
    schema: {
      serviceAccountEmail: Element({
        label: "P0 service account human-readable identifier",
        type: "generated",
      }),
      serviceAccountId: Element({
        label: "P0 service account machine identifier",
        type: "generated",
      }),
    },
  }),
  "iam-write": ItemComponent({
    type: "string", // value is Entra ID tenant ID
    label: "IAM management",
    description: "Assign users to Entra roles and add users to groups",
    maxItems: 1,
    maturity: "ga",
    schema: {
      sovereignCloudId: Element({
        label: "Sovereign cloud ID",
        type: "select",
        default: "AzureCloud",
        options: {
          AzureCloud: { label: "AzureCloud", maturity: "ga", schema: {} },
          AzureUSGovernment: {
            label: "AzureUSGovernment",
            maturity: "beta",
            schema: {},
          },
        },
        step: "new",
      }),
      clientId: Element({
        label: "Entra ID application client ID",
        type: "string",
        validator: async (_id, field) => {
          if (!field) return "Entra application client ID is required.";
          if (!field.match(UUID_PATTERN))
            return "Expected application client ID (UUID format)";
        },
      }),
      emailField: Element({
        label: "Select the user property that contains each user's email",
        type: "select",
        default: "userPrincipalName",
        options: {
          userPrincipalName: {
            label: "userPrincipalName",
            maturity: "ga",
            schema: {},
          },
          mail: { label: "mail", maturity: "ga", schema: {} },
          otherMails: { label: "otherMails", maturity: "ga", schema: {} },
        },
      }),
    },
    validator: async (_id, field) => {
      if (!field) return "Entra tenant ID is required.";
      if (!field.match(UUID_PATTERN))
        return "Expected Entra tenant ID (UUID format)";
    },
  }),
});
